import {h, Fragment} from "preact"
import { useState } from 'preact/hooks'

export default SwatchSelector = ({ product, onImageChange }) => {
    const [selectedVariantId, setSelectedVariantId] = useState(null);

    // Get variant combinations with their images
    const getVariantCombinations = () => {
        if (!product.skus || product.skus.length <= 1) return [];

        const combinations = new Map();
        const uniqueRimColors = new Set();
        
        product.skus.forEach(variant => {
            // Get body color and rim color from customFields
            const bodyColor = variant.customFields.find(field => field.key === 'canvas color')?.value;
            const rimColor = variant.customFields.find(field => field.key === 'rim color')?.value;

            if (bodyColor && rimColor) {
                // Create a unique key for this combination
                const combinationKey = `${bodyColor}_${rimColor}`;
                
                // Only add if we haven't seen this combination before
                if (!combinations.has(combinationKey)) {
                    // Extract just the base body color (e.g., "Natural" from "Natural w/ 2\" casters")
                    const baseBodyColor = bodyColor.split(' w/')[0].toLowerCase();
                    // Extract base rim color (e.g., "Grey" from "Grey Vinyl")
                    const baseRimColor = rimColor.split(' ')[0].toLowerCase();

                    combinations.set(combinationKey, {
                        bodyColor: baseBodyColor,
                        rimColor: baseRimColor,
                        variantId: variant.id,
                        imageUrl: variant.imageUrl
                    });

                    // Add to unique rim colors set
                    uniqueRimColors.add(baseRimColor);
                }
            }
        });

        return {
            combinations: Array.from(combinations.values()),
            uniqueRimColorsCount: uniqueRimColors.size
        };
    };

    const handleSwatchClick = (e, combination) => {
        e.preventDefault();
        e.stopPropagation();
        
        setSelectedVariantId(combination.variantId);
        onImageChange(combination.imageUrl);
    };

    const { combinations, uniqueRimColorsCount } = getVariantCombinations();
    const displayLimit = 4;

    return (
        <div class="card-swatches" onClick={e => e.stopPropagation()}>
            {combinations.slice(0, displayLimit).map(combination => (
                <div 
                    class={`card-swatch-body value-color-dot ${combination.bodyColor}${combination.variantId === selectedVariantId ? ' selected' : ''}`}
                    data-variant-id={combination.variantId}
                    data-image-url={combination.imageUrl}
                    onClick={(e) => handleSwatchClick(e, combination)}
                >
                    <div class={`card-swatch-rim value-color-dot ${combination.rimColor}`}></div>
                </div>
            ))}
            {uniqueRimColorsCount > displayLimit && 
                <span class="P-12 more-mobile" onClick={e => e.stopPropagation()}>
                    +{uniqueRimColorsCount - displayLimit}
                </span>
            }
        </div>
    );
};